export default "/_next/static/images/intercom-logo-4709354d0910a2ae51491a79eff56759.png";